import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import Tool from './Tool';
import { OptimizedBook } from './Book';
import { uniqueId } from 'lodash';
import { Temp } from './Temp';
import { TempChapter } from './Chapter';
import { Model, Ordenable, Versionable } from './Model';

export type LessonTab =
  | 'details'
  | 's-material'
  | 't-material'
  | 'activities'
  | 'challenge';

export type LessonUpdateKeyType = 'course' | 'class';

export default class Lesson extends Model implements Ordenable, Versionable {
  courseId!: number;
  name: string = '';
  description!: string;
  bannerImg?: string;
  toolUrl?: string;
  instructionsUrl?: string;
  motivation?: {
    message: string;
  };
  activities: number[] = [];
  book!: OptimizedBook | null;
  teacherBook!: number | null;
  status!: VersioningStatusEnum;
  order!: number;
  version!: number;
  readBook!: number;
  challenge!: number | null;
  tools: Tool[] = [];
  teacherRating?: {
    average: number | null;
    count: number;
  };
  inBank!: boolean;
  isPublicInBank!: boolean;
  author!: number;
  tagsIds!: number[];
  resources!: number[];
  allowedUnitsIds?: number[] = [];

  constructor(lesson?: Partial<Lesson>) {
    super();
    Object.assign(this, lesson);
  }
}

export class TempLesson extends Lesson implements Temp {
  tempId?: string = uniqueId();
  chapters?: TempChapter[];

  constructor(tempLesson?: Partial<TempLesson>) {
    super();
    Object.assign(this, tempLesson);
  }
}

export interface LessonMeta {
  id: number;
  originCourse: string;
  coursesCount: number;
}

export function implementsOfLesson(obj: any): obj is Lesson {
  if (!obj) return false;

  return (
    'id' in obj &&
    'name' in obj &&
    'description' in obj &&
    'activities' in obj &&
    'book' in obj &&
    'teacherBook' in obj &&
    'status' in obj &&
    'version' in obj &&
    'challenge' in obj &&
    'tools' in obj &&
    'inBank' in obj &&
    'author' in obj
  );
}
